{
  "city-card": {
    "text": {
      "explore-top-salons": "Entdecke Top-Salons in"
    }
  }
}
